function conditionalPropType(predicateFun, truthyValidator, falsyValidator) {
  return function conditionalValidator(props, propName, componentName, location, propFullName) {
    const conditionValue = predicateFun(props, propName, componentName, location, propFullName);
    for (var _len = arguments.length, args = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }
    if (conditionValue) {
      return truthyValidator(props, propName, componentName, location, propFullName, ...args);
    }
    return falsyValidator(props, propName, componentName, location, propFullName, ...args);
  };
}
export { conditionalPropType };